import { z } from 'zod';
import { UnionOfKeys } from '@anytag/shared-types';
import { SearchSchema } from '@anytag/shared-validations';
import { MarketplaceCampaignPostStatusForSearch } from '@anytag/graphql';

export const MarketplacePostsFilterSchema = z.object({
  keyword: SearchSchema.types.string(),
  status: SearchSchema.types.enum(MarketplaceCampaignPostStatusForSearch)
});
export const MarketplacePostsSearchSchema = SearchSchema.create({
  filter: { schema: MarketplacePostsFilterSchema }
});

export type MarketplacePostsSearchSchemaTypes = z.infer<typeof MarketplacePostsSearchSchema>;
export type MarketplacePostsFilterFormValues = MarketplacePostsSearchSchemaTypes['filter'];
export type MarketplacePostsFilterFormKeys = UnionOfKeys<MarketplacePostsFilterFormValues>;
